// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/track_vision_presence.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionPresenceKind } from "./vision_presence_pb";
import { file_vision_projects_v1_vision_presence } from "./vision_presence_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/track_vision_presence.proto.
 */
export const file_vision_projects_v1_track_vision_presence: GenFile = /*@__PURE__*/
  fileDesc("Ci52aXNpb24vcHJvamVjdHMvdjEvdHJhY2tfdmlzaW9uX3ByZXNlbmNlLnByb3RvEhlwcm90b3MudmlzaW9uLnByb2plY3RzLnYxIrQCChpUcmFja1Zpc2lvblByZXNlbmNlUmVxdWVzdBJMCgZwYXJhbXMYASABKAsyPC5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLlRyYWNrVmlzaW9uUHJlc2VuY2VSZXF1ZXN0LlBhcmFtcxrHAQoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSOwoEa2luZBgCIAEoDjItLnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuVmlzaW9uUHJlc2VuY2VLaW5kEhAKCGltYWdlX2lkGAMgASgJEhUKDWdlbmVyYXRpb25faWQYBCABKAkSIgoaZ3JhZGluZ19sb2NrX2dlbmVyYXRpb25faWQYBSABKAkSHwoXY3JvcF9sb2NrX2dlbmVyYXRpb25faWQYBiABKAkidgobVHJhY2tWaXNpb25QcmVzZW5jZVJlc3BvbnNlEk0KBnJlc3VsdBgBIAEoCzI9LnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuVHJhY2tWaXNpb25QcmVzZW5jZVJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw", [file_vision_projects_v1_vision_presence]);

/**
 * @generated from message protos.vision.projects.v1.TrackVisionPresenceRequest
 */
export type TrackVisionPresenceRequest = Message<"protos.vision.projects.v1.TrackVisionPresenceRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.TrackVisionPresenceRequest.Params params = 1;
   */
  params?: TrackVisionPresenceRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.TrackVisionPresenceRequest.
 * Use `create(TrackVisionPresenceRequestSchema)` to create a new message.
 */
export const TrackVisionPresenceRequestSchema: GenMessage<TrackVisionPresenceRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_track_vision_presence, 0);

/**
 * @generated from message protos.vision.projects.v1.TrackVisionPresenceRequest.Params
 */
export type TrackVisionPresenceRequest_Params = Message<"protos.vision.projects.v1.TrackVisionPresenceRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.projects.v1.VisionPresenceKind kind = 2;
   */
  kind: VisionPresenceKind;

  /**
   * @generated from field: string image_id = 3;
   */
  imageId: string;

  /**
   * @generated from field: string generation_id = 4;
   */
  generationId: string;

  /**
   * @generated from field: string grading_lock_generation_id = 5;
   */
  gradingLockGenerationId: string;

  /**
   * @generated from field: string crop_lock_generation_id = 6;
   */
  cropLockGenerationId: string;
};

/**
 * Describes the message protos.vision.projects.v1.TrackVisionPresenceRequest.Params.
 * Use `create(TrackVisionPresenceRequest_ParamsSchema)` to create a new message.
 */
export const TrackVisionPresenceRequest_ParamsSchema: GenMessage<TrackVisionPresenceRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_track_vision_presence, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.TrackVisionPresenceResponse
 */
export type TrackVisionPresenceResponse = Message<"protos.vision.projects.v1.TrackVisionPresenceResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.TrackVisionPresenceResponse.Result result = 1;
   */
  result?: TrackVisionPresenceResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.TrackVisionPresenceResponse.
 * Use `create(TrackVisionPresenceResponseSchema)` to create a new message.
 */
export const TrackVisionPresenceResponseSchema: GenMessage<TrackVisionPresenceResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_track_vision_presence, 1);

/**
 * @generated from message protos.vision.projects.v1.TrackVisionPresenceResponse.Result
 */
export type TrackVisionPresenceResponse_Result = Message<"protos.vision.projects.v1.TrackVisionPresenceResponse.Result"> & {
};

/**
 * Describes the message protos.vision.projects.v1.TrackVisionPresenceResponse.Result.
 * Use `create(TrackVisionPresenceResponse_ResultSchema)` to create a new message.
 */
export const TrackVisionPresenceResponse_ResultSchema: GenMessage<TrackVisionPresenceResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_track_vision_presence, 1, 0);

